import React from 'react';

import classnames from 'classnames/bind';
import style from './banner.module.scss';
const cx = classnames.bind(style);

interface GateProps {
  onPracticeClick: () => void;
  onHistoryClick: () => void;
}

const InterviewPracticeGateBanner = (props: GateProps) => {
  return (
    <div className={cx('banner')}>
      <div className={cx('contents')}>
        <div className={cx('titleWrap')}>
          <div className={cx('desc')}>면접 연습, 잡다에서 끝내자</div>
          <div className={cx('title')}>
            기업별 예상 면접 질문부터
            <strong>면접 연습까지 한 번에</strong>
          </div>
          <div className={cx('btnWrap')}>
            <button className={cx('btn', 'btnPractice')} onClick={props.onPracticeClick}>
              면접 연습 하러가기
            </button>
            <button className={cx('btn', 'btnHistory')} onClick={props.onHistoryClick}>
              연습 기록 확인하기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterviewPracticeGateBanner;
